import mapValues from 'lodash/mapValues';

import { JsonSchemaBasicObject } from '@evidentid/json-schema/interfaces/JsonSchema';

import {
    getRequirementDisplayName,
    RequirementLabels,
} from '@/components/migrated-compliance-section/migratedCompliance';

export const MIGRATED_COMPLIANCE_DISPLAY_FORMAT = 'MIGRATED_COMPLIANCE';

// Presents the `exceptions` group of the Add Entity schema as the "Migrate existing compliance"
// section: tags it so the form renders the section component, and titles each date by the
// requirement name alone, using the relying party's own label for it where there is one. The
// schema built for bulk import keeps its longer titles.
export function applyMigratedComplianceSchema(
    schema: JsonSchemaBasicObject,
    labels?: RequirementLabels,
): JsonSchemaBasicObject {
    const exceptions = schema.properties.exceptions as JsonSchemaBasicObject | undefined;

    if (!exceptions || Object.keys(exceptions.properties).length === 0) {
        return schema;
    }

    return {
        ...schema,
        properties: {
            ...schema.properties,
            exceptions: {
                ...exceptions,
                displayFormat: MIGRATED_COMPLIANCE_DISPLAY_FORMAT,
                properties: mapValues(exceptions.properties, (property, requirementType) => ({
                    ...property,
                    title: getRequirementDisplayName(requirementType, labels),
                })),
            } as JsonSchemaBasicObject,
        },
    };
}
